import Button from 'components/controls/buttons/button';
import styles from './dropdown-navigation.module.scss';
import { Link } from 'src/navigation';
import { useRef, useEffect, useState } from 'react';
import ChevronDown from 'assets/icons/chevron-down.svg';

const DropdownNavigation = ({ text, links }: Props) => {
	const wrapperRef = useRef(undefined);
	const [open, setOpen] = useState(false);

	const handleClick = () => setOpen(!open);
	useEffect(() => {
		function handleClickOutside(event) {
			if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
				setOpen(false);
			}
		}
		// Bind the event listener
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [wrapperRef]);

	return (
		<div className={styles.container} ref={wrapperRef}>
			<Button
				className={styles.button}
				onClick={handleClick}
				appearance="secondary"
			>
				{text}
				<ChevronDown
					className={`${styles.icon} ${open ? styles.up : styles.down}`}
				/>
			</Button>
			{open && (
				<div className={styles.links}>
					{links?.map((link) => {
						return (
							<Link className={styles.link} key={link.text} href={link.href}>
								{link.text}
							</Link>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default DropdownNavigation;

interface Props {
	text: any;
	links: { text: string; href: string }[];
}
